import { QueryFunction } from "react-query";
import { get } from "src/api";
import { MagicGoalList } from "src/types";

export const getList: [string, QueryFunction<MagicGoalList>] = [
  "listMagic",
  () => get<MagicGoalList>("/goal"),
];
